import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class CriteresDevis {
  constructor (
    quantite?: number,
    tonnage?: number,
    moisLivraison?: string,
    reglement?: string
  ) {
    this.quantite = quantite as any;
    this.tonnage = tonnage as any;
    this.moisLivraison = moisLivraison as any;
    this.reglement = reglement as any;
  }

  @JsonProperty(Number)
  @Optional
  quantite: number;

  @JsonProperty(Number)
  @Optional
  tonnage: number;

  @JsonProperty(String)
  @Optional
  moisLivraison: string;

  @JsonProperty(String)
  @Optional
  reglement: string;
}
